import { exec } from "@kakaopay-common/payweb-core";
import { validateHeightParameter, nomalizeHeightValue } from "../../utils/validateHeightParameter.mjs";
import { INTERFACE, NONE_INDENTIFIER } from "../../constants.mjs";
import { Device } from "@kakaopay-common/user-agent";
import getSafeArea from "../../utils/getSafeArea.mjs";
var BOTTOM_PLACEHOLDER_TYPE = /* @__PURE__ */ ((BOTTOM_PLACEHOLDER_TYPE2) => {
  BOTTOM_PLACEHOLDER_TYPE2["NONE"] = "NONE";
  BOTTOM_PLACEHOLDER_TYPE2["PLACEHOLDER1"] = "PLACEHOLDER1";
  BOTTOM_PLACEHOLDER_TYPE2["PLACEHOLDER2"] = "PLACEHOLDER2";
  return BOTTOM_PLACEHOLDER_TYPE2;
})(BOTTOM_PLACEHOLDER_TYPE || {});
function showBottomWebview({
  url,
  height = "50%",
  color_scheme,
  placeholder = "NONE",
  post_body,
  hidden,
  dismiss_enabled
}) {
  if (!validateHeightParameter(height)) {
    return Promise.resolve({
      command: INTERFACE.PAYWEB_BOTTOM,
      success: false,
      error: {
        code: "parameter_error",
        message: "height의 형식이 잘못되었습니다."
      },
      extras: {
        identifier: NONE_INDENTIFIER
      }
    });
  }
  height = nomalizeHeightValue(height);
  if (Device.isIos() && height.endsWith("px") && getSafeArea().bottom > 0) {
    let heightValue = Number(height.replace("px", ""));
    heightValue += getSafeArea().bottom;
    height = heightValue + "px";
  }
  const command = {
    command: INTERFACE.PAYWEB_BOTTOM,
    parameters: {
      url,
      placeholder,
      ...color_scheme && { color_scheme },
      ...height && { height },
      ...post_body && { post_body },
      ...typeof hidden !== "undefined" && { hidden },
      ...typeof dismiss_enabled !== "undefined" && { dismiss_enabled }
    }
  };
  return exec(command);
}
export {
  BOTTOM_PLACEHOLDER_TYPE,
  showBottomWebview
};
